import { render, staticRenderFns } from "./AppliancesCurrentData.vue?vue&type=template&id=1bdacecf&"
import script from "./AppliancesCurrentData.vue?vue&type=script&lang=js&"
export * from "./AppliancesCurrentData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports